"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.focusRingColors = exports.danger = exports.success = exports.interactionSecondaryDark = exports.interactionSecondaryLight = exports.interactionPrimaryDarkFg = exports.interactionPrimaryDark = exports.interactionPrimaryLightFg = exports.interactionPrimaryLight = exports.snowWhiteAlpha = void 0;

var _toColorString = _interopRequireDefault(require("polished/lib/color/toColorString"));

var _color = _interopRequireDefault(require("@decisiv/design-tokens/lib/color"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { keys.push.apply(keys, Object.getOwnPropertySymbols(object)); } if (enumerableOnly) keys = keys.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var base = _color.default.base,
    interaction = _color.default.interaction,
    status = _color.default.status,
    opacity = _color.default.opacity;
var pacificOcean = interaction.pacificOcean,
    arcticOcean = interaction.arcticOcean,
    atlanticOcean = interaction.atlanticOcean,
    indianOcean = interaction.indianOcean;
var snowWhiteAlpha = (0, _toColorString.default)(_objectSpread({}, base.snowWhite, {
  alpha: 0.2
}));
exports.snowWhiteAlpha = snowWhiteAlpha;
var interactionPrimaryLight = (0, _toColorString.default)(pacificOcean);
exports.interactionPrimaryLight = interactionPrimaryLight;
var interactionPrimaryLightFg = (0, _toColorString.default)(pacificOcean.fg);
exports.interactionPrimaryLightFg = interactionPrimaryLightFg;
var interactionPrimaryDark = (0, _toColorString.default)(arcticOcean);
exports.interactionPrimaryDark = interactionPrimaryDark;
var interactionPrimaryDarkFg = (0, _toColorString.default)(arcticOcean.fg);
exports.interactionPrimaryDarkFg = interactionPrimaryDarkFg;
var interactionSecondaryLight = (0, _toColorString.default)(indianOcean);
exports.interactionSecondaryLight = interactionSecondaryLight;
var interactionSecondaryDark = (0, _toColorString.default)(atlanticOcean);
exports.interactionSecondaryDark = interactionSecondaryDark;
var success = (0, _toColorString.default)(status.success.medium);
exports.success = success;
var danger = (0, _toColorString.default)(status.danger.medium);
exports.danger = danger;
var invertedFocusRing = {
  border: (0, _toColorString.default)(base.blackSheep),
  shadow: (0, _toColorString.default)(opacity.charcoal40)
};
var focusRingColors = {
  light: {
    normal: {
      primary: {
        border: interactionPrimaryLight,
        shadow: (0, _toColorString.default)(opacity.fullMoon50)
      },
      secondary: {
        border: interactionPrimaryLight,
        shadow: (0, _toColorString.default)(interaction.pacificOcean40)
      }
    },
    inverted: {
      primary: invertedFocusRing,
      secondary: invertedFocusRing
    },
    ghost: {
      border: interactionPrimaryLight,
      shadow: (0, _toColorString.default)(interaction.pacificOcean40)
    }
  },
  dark: {
    normal: {
      primary: {
        border: interactionPrimaryDark,
        shadow: (0, _toColorString.default)(opacity.midnight50)
      },
      secondary: {
        border: interactionPrimaryDark,
        shadow: (0, _toColorString.default)(interaction.arcticOcean40)
      }
    },
    inverted: {
      primary: invertedFocusRing,
      secondary: invertedFocusRing
    },
    ghost: {
      border: interactionPrimaryDark,
      shadow: (0, _toColorString.default)(interaction.arcticOcean40)
    }
  }
};
exports.focusRingColors = focusRingColors;